const DEFAULT_URL_BASE = "";

const absUrl = (path, urlBase = DEFAULT_URL_BASE) => {
  return `${urlBase}${path}`;
};

export default absUrl;
